(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recongition-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-svs-player]').forEach(function (player) {
      var playBtn = player.querySelector('[data-svs-play]');
      var thumb = player.querySelector('[data-svs-thumb]');
      var media = player.querySelector('[data-svs-media]');
      if (!playBtn || !thumb || !media) return;

      playBtn.addEventListener('click', function () {
        var type = player.getAttribute('data-video-type');
        var src = player.getAttribute('data-video-src');
        if (!src) return;

        media.innerHTML = '';

        if (type === 'hosted') {
          var video = document.createElement('video');
          video.src = src;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          media.appendChild(video);
        } else {
          var iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          media.appendChild(iframe);
        }

        thumb.hidden = true;
        media.hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["submition-from"] && !Shopify.designMode) return;
  try {
    
//   function onShopifyFormReady() {
//     const hostElement = document.querySelector('shopify-forms-embed');

//     const styleTag = document.createElement('style');
//     styleTag.textContent = `
//         .app-form-heading{
//             display: flex;
//             justify-content: space-between;
//             gap: 10px;
//             align-items: center;
//             border-bottom: 1px solid #00000050;
//             padding: 10px 0;
//             margin-top: 20px;
//             margin-bottom: 10px;
//         }
//         .app-form-heading.custom-step-1 {
//             margin-top: 0;
//         }
//         .app-form-heading p.step_txt{
//             margin: 0;
//             font-size: 14px;
//             color: #00000090;
//         }
//         .app-form-heading p.heading_txt{
//             margin: 0;
//             font-size: 22px;
//             font-weight: 600;
//             text-transform: uppercase;
//             color: #000;
//         }
//         @media (max-width:749px){
//             .app-form-heading p.heading_txt{
//                 font-size: 18px;
//             }
//             ._container_3eyaa_70{
//                 grid-template-columns: 1fr !important;
//             }
//         }
//       `;

//     hostElement.shadowRoot.appendChild(styleTag);
//   }
//   const observer = new MutationObserver((mutations, obs) => {
//     const formElement = document.querySelector('shopify-forms-embed');

//     if (formElement) {
//       onShopifyFormReady();
//       obs.disconnect();
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });

// document.addEventListener('DOMContentLoaded', () => {
//   const FORM_SELECTOR = '._formFieldset_jnbzb_92';

//   function findElementDeep(selector, root = document) {
//     const element = root.querySelector?.(selector);
//     if (element) {
//       return element;
//     }
//     const allElements = root.querySelectorAll?.('*') || [];
//     for (const el of allElements) {
//       if (el.shadowRoot) {
//         const found = findElementDeep(selector, el.shadowRoot);

//         if (found) {
//           return found;
//         }
//       }
//     }
//     return null;
//   }

//   function createCustomElement(className, heading, step) {
//     const element = document.createElement('div');
//     element.className = className;
//     element.innerHTML = `
//       <p class="heading_txt">${heading}</p>
//       <p class="step_txt">${step}</p>
//     `;
//     return element;
//   }

//   function addCustomElements() {
//     const form = findElementDeep(FORM_SELECTOR);
//     if (!form) {
//       return false;
//     }
//     if (form.querySelector('.custom-step-1')) {
//       return true;
//     }
//     const children = Array.from(form.children);
//     console.log('Form children:', children);
//     const element1 = createCustomElement(
//       'app-form-heading custom-step-1',
//       'About you',
//       'STEP 01'
//     );
//     if (children[0]) {
//       children[0].after(element1);
//     }
//     const element2 = createCustomElement(
//       'app-form-heading custom-step-2',
//       'Your story',
//       'STEP 02'
//     );
//     if (children[7]) {
//       children[7].after(element2);
//     }
//     const element3 = createCustomElement(
//       'app-form-heading custom-step-3',
//       'Portfolio',
//       'STEP 03'
//     );
//     if (children[10]) {
//       children[10].after(element3);
//     }
//     return true;
//   }
//   addCustomElements();
//   const observer = new MutationObserver(() => {
//     addCustomElements();
//   });
//   observer.observe(document.documentElement, {
//     childList: true,
//     subtree: true
//   });
// });

(function () {
  const FORM_SELECTOR = '._formFieldset_jnbzb_92';
  const HOST_SELECTOR = 'shopify-forms-embed';
  const STYLE_ID = 'custom-shopify-form-styles';
  function findElementDeep(selector, root = document) {
    const element = root.querySelector?.(selector);
    if (element) {
      return element;
    }
    const allElements = root.querySelectorAll?.('*') || [];
    for (const el of allElements) {
      if (el.shadowRoot) {
        const found = findElementDeep(selector, el.shadowRoot);

        if (found) {
          return found;
        }
      }
    }
    return null;
  }
  function addCustomStyles(hostElement) {
    if (!hostElement?.shadowRoot) return;
    if (hostElement.shadowRoot.getElementById(STYLE_ID)) {
      return;
    }
    const styleTag = document.createElement('style');
    styleTag.id = STYLE_ID;
    styleTag.textContent = `
      .app-form-heading {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid #00000050;
        padding: 10px 0;
        margin-top: 20px;
        margin-bottom: 10px;
      }

      .app-form-heading.custom-step-1 {
        margin-top: 0;
      }

      .app-form-heading p {
        margin: 0;
      }

      .app-form-heading .step_txt {
        font-size: 14px;
        color: #00000090;
      }

      .app-form-heading .heading_txt {
        font-size: 22px;
        font-weight: 600;
        text-transform: uppercase;
        color: #000;
      }

      @media (max-width: 749px) {
        .app-form-heading .heading_txt {
          font-size: 18px;
        }

        ._container_3eyaa_70 {
          grid-template-columns: 1fr !important;
        }
      }
    `;
    hostElement.shadowRoot.appendChild(styleTag);
  }
  function createCustomElement(className, heading, step) {
    const element = document.createElement('div');

    element.className = `app-form-heading ${className}`;

    element.innerHTML = `
      <p class="heading_txt">${heading}</p>
      <p class="step_txt">${step}</p>
    `;

    return element;
  }
  function addCustomElements(form) {
    if (!form) return;
    if (form.querySelector('.custom-step-1')) {
      return;
    }
    const children = Array.from(form.children);

    if (children[0]) {
      children[0].after(
        createCustomElement(
          'custom-step-1',
          'About you',
          'STEP 01'
        )
      );
    }
    if (children[7]) {
      children[7].after(
        createCustomElement(
          'custom-step-2',
          'Your story',
          'STEP 02'
        )
      );
    }
    if (children[10]) {
      children[10].after(
        createCustomElement(
          'custom-step-3',
          'Portfolio',
          'STEP 03'
        )
      );
    }
  }
  function initShopifyForm() {
    const hostElement = document.querySelector(HOST_SELECTOR);

    if (!hostElement) {
      return false;
    }

    addCustomStyles(hostElement);

    // Find form inside Shadow DOM
    const formElement = findElementDeep(FORM_SELECTOR);

    if (!formElement) {
      return false;
    }

    // Add custom headings
    addCustomElements(formElement);

    return true;
  }

  /**
   * Try immediately
   */
  function start() {
    initShopifyForm();

    // Shopify Forms can render asynchronously
    const observer = new MutationObserver(() => {
      const initialized = initShopifyForm();

      // Once everything is available, we can disconnect
      if (initialized) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Start after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-svs-player]').forEach(function (player) {
      var playBtn = player.querySelector('[data-svs-play]');
      var thumb = player.querySelector('[data-svs-thumb]');
      var media = player.querySelector('[data-svs-media]');
      if (!playBtn || !thumb || !media) return;

      playBtn.addEventListener('click', function () {
        var type = player.getAttribute('data-video-type');
        var src = player.getAttribute('data-video-src');
        if (!src) return;

        media.innerHTML = '';

        if (type === 'hosted') {
          var video = document.createElement('video');
          video.src = src;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          media.appendChild(video);
        } else {
          var iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          media.appendChild(iframe);
        }

        thumb.hidden = true;
        media.hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
